import type { QrReviewPageRecord } from '../types';

/** Minimum resolution a page must reach to count toward confidence — the same
 *  line the panel's resolution dot uses. */
export const CONFIDENT_MIN_DPI = 300;

/** The batch's confidence: the share of pages that pass both quality checks
 *  the panel lists — QR matched its `{container}-P{n}` value, and at least
 *  `CONFIDENT_MIN_DPI`. Reads `qr_status` and `dpi` only, so a verdict never
 *  moves it. */
export function deriveBatchConfidence(
  pages: Pick<QrReviewPageRecord, 'qr_status' | 'dpi'>[]
): { confident: number; total: number; percent: number } {
  const total = pages.length;
  const confident = pages.filter(
    (p) => p.qr_status === 'success' && p.dpi >= CONFIDENT_MIN_DPI
  ).length;
  return {
    confident,
    total,
    percent: total === 0 ? 0 : Math.round((confident / total) * 100)
  };
}
